import React , {Component} from 'react';
import {Link} from "react-router-dom";
import backIcon from './../assets/images/icons/back-2.svg';
import * as vars from "./Vars";
import * as axios from "axios/index";
import Loader from './loader/ArticleLoader';

class Article extends Component{

    constructor(props){

        super(props)
        this.state = {
            page : 1 ,
            articles : [] ,
            requestLoading : true ,
            hasMore : true ,
        }
    }



    componentDidMount(){
        axios.get(vars.Url +'api/v1/article'  , {
            params : {
                'api_token' : localStorage.getItem("api_token") ,
                'page' : this.state.page
            }

        } )
            .then(response => {
                let data = response.data.data
                // console.log(data.articles)
                this.setState({
                    requestLoading : false ,
                    articles : data.articles ,
                    hasMore : data.hasMore  ,
                    page : this.state.page + 1
                })
            })
            .catch(error => {
                // console.log(error)
            })


        document.addEventListener('scroll', this.trackScrolling)
    }


    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight + 100;
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById('body');
        if (this.isBottom(wrappedElement)) {

            if (this.state.hasMore === true && this.state.requestLoading === false)
            {
                this.setState({
                    requestLoading :true ,
                })
                axios.post(vars.Url +'api/v1/article' ,  {
                    params : {
                        'api_token' : localStorage.getItem("api_token") ,
                        'page' : this.state.page
                    }

                } )
                    .then(response => {
                        let data = response.data.data
                        this.setState({
                            requestLoading : false ,
                            articles : [...this.state.articles , ...data.articles] ,
                            hasMore : data.hasMore ,
                            page : this.state.page + 1
                        })
                    })
                    .catch(error => {
                        // console.log(error)
                    })
            }

        }
    }

    componentWillUnmount(){
        document.removeEventListener('scroll', this.trackScrolling)
    }


    render(){
        return(

            <div id="main-custom-1" className="text-decoration-none">


                <header id="header-3">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">
                                <div className="items-container">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <Link to="/">
                                                <span>
                                                    <img src={backIcon} alt="back" className="item-icon" />
                                                </span>
                                            </Link>
                                            <span className="title">
                                                اطلاع‌رسانی‌ها
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>


                <div className="container p-0 mt-5">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">
                            <div className="items-container items-container-custom-1">


                                {
                                    this.state.articles.map((article , index) =>

                                        <div className={"card-custom-16 " + (article.unread === true ? "unread" : "")} key={index}>
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-auto pl-2">
                                                    <a href={article.url} target="_blank" className="img-container">
                                                        <img src={article.imagePreview} alt={article.title} className="item-icon" />
                                                    </a>
                                                </div>

                                                <div className="col">
                                                    <div className="row no-gutters">
                                                        <div className="col">
                                                            <a href={article.url} target="_blank" className="title">
                                                                {article.title}
                                                            </a>
                                                        </div>
                                                        <div className="col-auto text-left">
                                                            <div className="date">
                                                                {article.publishedDate}
                                                            </div>
                                                            <span className="unread" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )
                                }

                                {
                                    this.state.requestLoading === true ? (<Loader />) : (``)
                                }

                            </div>
                        </div>
                    </div>
                </div>




            </div>
        )
    }
}
export default Article;